import React from "react";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router";
import { setAccount } from "../../store/panel";
import * as API from "../../lib/api";
import * as Links from "../../lib/links";

export default function Action() {
    const { hash } = useParams();
    const history = useHistory();
    const dispatch = useDispatch();

    React.useEffect(() => {
        API.Send("/a", { hash }).then(res => {
            console.log(">>>", res);
            if (res.confirmed) {
                API.AccountCheck()
                    .then(res => {
                        if (!res?.ok) {
                            return null;
                        }

                        delete res.ok;
                        return res;
                    })
                    .then(account => {
                        if (!account) {
                            history.push(Links.Login());
                        } else {
                            dispatch(setAccount(account));
                            history.push(Links.Dashboard());
                        }
                    });

                return;
            }

            if (res.recovery) {
                API.AccountCheck()
                    .then(res => {
                        if (!res?.ok) {
                            return null;
                        }

                        delete res.ok;
                        return res;
                    })
                    .then(account => {
                        dispatch(setAccount(account));
                        history.push(Links.AccountRecovery());
                    });

                return;
            }

            if (res.redirect) {
                window.location = res.redirect;
                return;
            }
        });
    }, [hash]);

    return null;
}
